import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as api from 'API/api'

const CheckAppointments = () => {
  
  const [appointmentId, setAppointmentId] = useState("");
  const [searched, setSearched] = useState(false);
  const [results, setResults] = useState([]);



  const handleSearch = async () => {
    setSearched(true);

    if (!appointmentId.trim()) {
      setResults([]);
      return;
    }

    try {
      
      const fetchedAppointments = await api.fetchAppointments(appointmentId);
      setResults(fetchedAppointments);
    } catch (error) {
      console.error("Error searching appointments:", error);
      setResults([]);
    }
  };


  return (
    <div className="mx-auto mt-5 flex w-[50%] flex-col justify-center rounded-2xl bg-white p-6 shadow-sm">
      <div className="flex flex-col items-center text-center">
        <h2 className="text-2xl font-semibold text-gray-900">
          Look up your appointment
        </h2>

        <div className="mt-4 flex w-full max-w-xl gap-2">
          <input
            type="text"
            value={appointmentId}
            onChange={(e) => setAppointmentId(e.target.value)}
            className="input flex-1 rounded-md border border-gray-300 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            placeholder="Enter Appointment ID (e.g. A7K3P9)"
          />
          <button
            type="button"
            onClick={handleSearch}
            className="cursor-pointer rounded-md bg-blue-600 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-500"
          >
            Search
          </button>
        </div>

        <p className="mt-3 text-sm text-gray-600">
          Please enter your Appointment ID to search your booking.
        </p>
      </div>

      {searched && (
        <div className="mt-8">
          {results.length === 0 ? (
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-5">
              <p className="text-sm font-medium text-gray-900">
                No appointment found with that ID.
              </p>
              <p className="mt-1 text-sm text-gray-600">
                Please check your Appointment ID or maybe book a new appointment.
              </p>

              <div className="mt-4">
                <Link
                  to="/appointments"
                  className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-500"
                >
                  Book an Appointment →
                </Link>
              </div>
            </div>
          ) : (
            <div className="grid gap-4 sm:grid-cols-2">
              {results.map((apt) => (
                <div
                  key={apt.appointmentId}
                  className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="text-xs font-semibold text-gray-500">
                        Appointment ID
                      </p>
                      <p className="mt-1 font-semibold text-gray-900">
                        {apt.appointmentId}
                      </p>
                    </div>
                    <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">
                      {apt.status}
                    </span>
                  </div>

                  <div className="mt-4 grid gap-3 text-sm">
                    <div>
                      <p className="text-xs font-semibold text-gray-500">Name</p>
                      <p className="mt-1 font-medium text-gray-900">
                        {apt.fullName}
                      </p>
                    </div>

                    <div>
                      <p className="text-xs font-semibold text-gray-500">
                        Date & Time
                      </p>
                      <p className="mt-1 font-medium text-gray-900">
                        {apt.date} · {apt.time}
                      </p>
                    </div>

                    <div>
                      <p className="text-xs font-semibold text-gray-500">
                        Vehicle
                      </p>
                      <p className="mt-1 font-medium text-gray-900">
                        {apt.vehicle.make} {apt.vehicle.model} · {apt.vehicle.year}
                      </p>
                    </div>

                    <div>
                      <p className="text-xs font-semibold text-gray-500">
                        Services
                      </p>
                      <p className="mt-1 font-medium text-gray-900">
                        {apt.services.join(", ")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>

  );
};

export default CheckAppointments;
